export { default as Faqs } from './Faqs';
